import React, { FC } from 'react';
import { t } from 'i18next';
import { useFormApi } from 'informed';
import moment from 'moment';
import { useNonSpammyFieldState } from '@common/hooks';
import { notEmptyValidator } from '@common/utils';
import { DateField } from '../../../../../legacyInputs';
import css from '../styles.module.scss';

const TIME_INTERVAL = 15;

interface IPickupTimeField {
  multilegField?: string;
}

const PickupTimeField: FC<IPickupTimeField> = ({ multilegField }) => {
  const formApi = useFormApi();
  const fieldName = multilegField ? `${multilegField}.pickup_time` : 'pickup_time';

  const { value: dropoff_time } = useNonSpammyFieldState<Date>(
    multilegField ? `${multilegField}.dropoff_time` : 'dropoff_time',
  );

  return (
    <div className={css.field} data-testid="mobility-planner-edit-form-pick-up-time">
      <DateField
        className={css.input}
        dateFormat="HH:mm"
        label={t('bookingDetails.pickupTime')}
        name={fieldName}
        showTimeSelect
        showTimeSelectOnly
        timeCaption={undefined}
        timeFormat="HH:mm"
        timeIntervals={TIME_INTERVAL}
        validate={notEmptyValidator}
        onChange={(value) => {
          if (moment(value).isAfter(dropoff_time) || moment(value).isSame(dropoff_time)) {
            formApi.setValue('dropoff_time', moment(value).add(TIME_INTERVAL, 'minutes').toDate());
          }
        }}
      />
    </div>
  );
};

export default PickupTimeField;
